// extracted by mini-css-extract-plugin
export default {"validBtn":"validBtn__bPx9s","svgInBtn":"svgInBtn__ZhuIB"};